export type HexColor = `#${string}`;

export interface PwaIcon {
  readonly purpose: "any" | "maskable";
  readonly sizes: `${number}x${number}`;
  readonly src: `/${string}`;
  readonly type: "image/png";
}

export interface WebAppManifest {
  readonly background_color: HexColor;
  readonly description: string;
  readonly display: "standalone";
  readonly icons: readonly PwaIcon[];
  readonly id: "/";
  readonly name: string;
  readonly orientation: "landscape";
  readonly scope: "/";
  readonly short_name: string;
  readonly start_url: "/";
  readonly theme_color: HexColor;
}

export interface PwaBuildMetadata {
  readonly assets: readonly `/${string}`[];
  readonly buildId: string;
  readonly buildKind: "acceptance" | "release";
  readonly version: string;
}

export const pwaConfig = {
  appleTouchIconPath: "/icons/snakely-apple-touch-180.png",
  backgroundColor: "#102a43",
  buildMetadataPath: "/pwa-build.json",
  manifestPath: "/manifest.webmanifest",
  serviceWorkerPath: "/service-worker.js",
  themeColor: "#102a43",
} as const satisfies {
  readonly appleTouchIconPath: `/${string}`;
  readonly backgroundColor: HexColor;
  readonly buildMetadataPath: `/${string}`;
  readonly manifestPath: `/${string}`;
  readonly serviceWorkerPath: `/${string}`;
  readonly themeColor: HexColor;
};

export const pwaIcons = [
  {
    purpose: "any",
    sizes: "192x192",
    src: "/icons/snakely-192.png",
    type: "image/png",
  },
  {
    purpose: "any",
    sizes: "512x512",
    src: "/icons/snakely-512.png",
    type: "image/png",
  },
  {
    purpose: "maskable",
    sizes: "512x512",
    src: "/icons/snakely-maskable-512.png",
    type: "image/png",
  },
] as const satisfies readonly PwaIcon[];

export const createWebAppManifest = (): WebAppManifest => ({
  background_color: pwaConfig.backgroundColor,
  description: "A sunny, child-friendly snake game.",
  display: "standalone",
  icons: pwaIcons,
  id: "/",
  name: "Snakely",
  orientation: "landscape",
  scope: "/",
  short_name: "Snakely",
  start_url: "/",
  theme_color: pwaConfig.themeColor,
});
